<template>
  <Legacy
    view="accounts"
    action="enquiries"
  />
</template>

<script>
import Legacy from '@/components/Application/Legacy'

export default {
  components: {
    Legacy
  },
  data () {
    return {
      title: 'Enquiries',
      breadcrumb: {
        name: 'Enquiries',
        route: { name: 'customerservice-enquiries' }
      }
    }
  }
}
</script>
